import React, { useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { Button, ModalFooter, Spinner, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import useSignup from './useSignup';

export const UnsubscribeStage = ({ token, apiUrl }) => {
  const { t } = useTranslation();
  const { unsubscribe, loading, error } = useSignup(apiUrl);
  const [hasUnsubscribed, setHasUnsubscribed] = useState(false);

  const { handleSubmit } = useForm();

  const onSubmit = useCallback(
    async (data) => {
      try {
        const response = await unsubscribe(token);

        if (response) {
          console.log('Unsubscribed successfully');
          setHasUnsubscribed(true);
        }
      } catch (error) {
        console.error('Unsubscribe failed:', error);
      }
    },
    [unsubscribe, setHasUnsubscribed, token],
  );

  if (hasUnsubscribed) {
    return <Text>{t('label.UnsubscribeSuccess')}</Text>;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <VStack spacing={4} align="stretch">
        <Text fontSize="sm">{t('label.unsubscribeInstruction')}</Text>
      </VStack>

      <ModalFooter>
        <Button type="submit" colorScheme="green" mb={2} isLoading={loading}>
          {loading ? <Spinner size="sm" mr={2} /> : null}
          {t('button.Unsubscribe')}
        </Button>
      </ModalFooter>

      {error && (
        <Text color="red.500" mt={2}>
          {t('label.UnsubscribeError')}
        </Text>
      )}
    </form>
  );
};
